export default [
  {
    text: 'Name',
    align: 'left',
    sortable: false,
    value: 'Team Member',
    visible: true,
    locked: true,
    order: 0,
    tooltip: `- Team Leader can see team 
      members' activities. Team 
      members will not see each other's 
      activity, regardless of team sharing 
      setting.  
      - Admin can see subaccounts' 
      activities 
      - You can see your own activity`,
  },
  {
    text: 'Email Sent',
    comparison: 'Email Sent %',
    align: 'left',
    sortable: true,
    value: 'Email Sent',
    visible: true,
    locked: false,
    tooltip: `Includes emails sent from 
      LionDesk and emails entered as 
      an Activity on Contact's Profile. 
      Emails sent via a 3rd party are not tracked`,
  },
  {
    text: 'Text Sent',
    comparison: 'Text Sent %',
    align: 'left',
    value: 'Text Sent',
    visible: true,
    locked: false,
    sortable: true,
    tooltip: `Includes text messages sent 
      from LionDesk (mobile app or 
      desktop) and texts entered as an
      Activity on Contact's Profile`,
  },

  {
    text: 'Outbound Calls',
    comparison: 'Outbound Calls %',
    align: 'left',
    value: 'Outbound Click to Call',
    visible: true,
    locked: false,
    sortable: true,
    tooltip: `Includes outbound calls made 
      from LionDesk (mobile app or 
      desktop) and outbound calls 
      entered as an Activity on Contact's Profile`,
  },
  {
    text: 'Comments',
    comparison: 'Comments %',
    align: 'left',
    value: 'Contact Comments',
    visible: true,
    locked: false,
    sortable: true,
    tooltip: `Includes comments entered as 
    an Activity on Contact's Profile`,
  },
  {
    text: 'Lead Assigned',
    comparison: 'Lead Assigned %',
    align: 'left',
    value: 'Lead Assigned',
    visible: true,
    locked: false,
    sortable: true,
    tooltip: 'Leads Assigned',
  },
  {
    text: 'Email Received',
    comparison: 'Email Received %',
    align: 'left',
    value: 'Email Received',
    visible: true,
    locked: false,
    sortable: true,
    tooltip: `Emails received on your 
    LionDesk Account`,
  },
  {
    text: 'Text Received',
    comparison: 'Text Received %',
    align: 'left',
    value: 'Text Received',
    visible: true,
    locked: false,
    sortable: true,
    tooltip: `Includes text messages send to 
    the user's LionDesk custom 
    number`,
  },
  {
    text: 'Inbound Calls',
    comparison: 'Inbound Calls %',
    align: 'left',
    value: 'Inbound Call',
    visible: false,
    locked: false,
    sortable: true,
    tooltip: 'Inbound Call',
  },
  {
    text: 'Email Opened',
    comparison: 'Email Opened %',
    align: 'left',
    value: 'Email Opened',
    visible: false,
    locked: false,
    sortable: true,
    tooltip: 'Email Opened',
  },
  {
    text: 'Email Clicked',
    comparison: 'Email Clicked %',
    align: 'left',
    value: 'Email Clicked',
    visible: false,
    locked: false,
    sortable: true,
    tooltip: 'Email Clicked',
  },
  {
    text: 'Email Sent Via 3rd Party',
    comparison: 'Email Sent Via 3rd Party %',
    align: 'left',
    value: 'Email Sent via 3rd Party',
    visible: false,
    locked: false,
    sortable: true,
    tooltip: `Emails synced from 
    your Gmail, Microsoft
    or Outlook`,
  },
];
